<template>
  <div v-if="visible" class="app-video-modal">
    <div class="app-video-modal__body ratio ratio-16x9">
      <iframe :src="`https://www.youtube.com/embed/${embedId}?rel=0&autoplay=1`" title="" allowfullscreen></iframe>
    </div>
    <button type="button" class="app-video-modal__close btn-plus" data-bs-dismiss="modal" aria-label="Close" @click.prevent="close"></button>
  </div>
</template>

<script>
  export default {
    name: "AppVideoModal",
    data() {
      return {
        storePopupName: 'Video'
      }
    },
    computed: {
      visible() {
        return this.$store.getters['Popups/hasVisiblePopup'](this.storePopupName)
      },
      embedId() {
        return this.$store.getters['Popups/getVideoModalEmbed']
      }
    },
    methods: {
      close() {
        this.$store.commit('Popups/closeAllPopups')
      },
    }
  }
</script>
